import { baseApi } from 'core/api';
import { useToastStore } from 'store/modules';

const state = () => ({
    _settings: [],
    _settingsLoading: false,
    _settingsLoadingError: false,
    _settingsList: [],
    _settingsListLoading: false,
    _settingsListLoadingError: false,
    _settingsUpdating: false,
});

const getters = {
    salesforceSettings: (state) => state._settings,
    salesforceSettingsLoading: (state) => state._settingsLoading,
    salesforceSettingsLoadingError: (state) => state._settingsLoadingError,
    salesforceAvailableSettingsList: (state) => state._settingsList,
    salesforceAvailableSettingsListLoading: (state) => state._settingsListLoading,
    salesforceAvailableSettingsListLoadingError: (state) => state._settingsListLoadingError,
    settingsUpdating: (state) => state._settingsUpdating,
};

const actions = {
    async getSalesforceAvailableSettingsList() {
        if (this._settingsListLoading) return;

        this._setSalesforceSettingsListLoad();

        return baseApi
            .get('integration/settings/salesforce/list')
            .then((response) => {
                this._setSalesforceSettingsListLoaded({
                    settings: response.data,
                });

                return response;
            })
            .catch((error) => {
                const message = error.response?.data?.message || 'Failed to load settings';

                this._setSalesforceSettingsListLoadError(message);

                useToastStore().showToast({
                    type: 'danger',
                    message: message,
                });

                return error;
            });
    },

    async getSalesforceSettingsList() {
        if (this._settingsLoading) return;

        this._setSalesforceSettingsLoad();

        return baseApi
            .get('integration/settings/salesforce')
            .then((response) => {
                this._setSalesforceSettingsLoaded({
                    settings: response.data.data,
                });

                return response.data.data;
            })
            .catch((error) => {
                const message = error.response?.data?.message || 'Failed to load settings';

                this._setSalesforceSettingsLoadError(message);

                useToastStore().showToast({
                    type: 'danger',
                    message: message,
                });

                return error;
            });
    },

    updateSalesforceSettings(params) {
        this._setSalesforceSettingsUpdating(true);
        return baseApi
            .put('integration/settings/salesforce', params)
            .then((response) => {
                this._setSalesforceSettingsUpdated(response.data.data);

                useToastStore().showToast({
                    type: 'success',
                    message: 'Settings saved.',
                });

                return response;
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: 'Error saving settings.',
                });

                return error;
            })
            .finally(() => {
                this._setSalesforceSettingsUpdating(false);
            });
    },
    updateSalesforceSettingsList(params) {
        this._setSalesforceSettingsUpdating(true);
        return baseApi
            .put('integration/settings/salesforce/list', { data: params })
            .then((response) => {
                this._setSalesforceSettingsUpdated(response.data.data);

                useToastStore().showToast({
                    type: 'success',
                    message: 'Settings saved.',
                });

                return response;
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: 'Error saving settings.',
                });

                return error;
            })
            .finally(() => {
                this._setSalesforceSettingsUpdating(false);
            });
    },

    // Private methods
    _setSalesforceSettingsLoad() {
        this._settingsLoading = true;
        this._settingsLoadingError = null;
    },

    _setSalesforceSettingsLoadError(message) {
        this._settingsLoading = false;
        this._settingsLoadingError = message;
        this._settings = [];
    },

    _setSalesforceSettingsLoaded({ settings }) {
        this._settingsLoading = false;
        this._settingsLoadingError = null;
        this._settings = settings;
    },

    _setSalesforceSettingsUpdated(data) {
        this._settings = data;
    },

    _setSalesforceSettingsUpdating(status) {
        this._settingsUpdating = status;
    },

    _setSalesforceSettingsListLoad() {
        this._settingsListLoading = true;
        this._settingsListLoadingError = null;
    },

    _setSalesforceSettingsListLoadError(message) {
        this._settingsListLoading = false;
        this._settingsListLoadingError = message;
        this._settingsList = [];
    },

    _setSalesforceSettingsListLoaded({ settings }) {
        this._settingsListLoading = false;
        this._settingsListLoadingError = null;
        this._settingsList = settings;
    },
};

export default {
    state,
    getters,
    actions,
};
